// src/utilities/dateUtils.js

export const formatDate = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', { year: 'numeric', month: 'short' });
};

export const formatDateToYYYYMMDD = (dateString) => {
  const date = new Date(dateString);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export const validateDateInputs = (rmHireDate, firstProductionDate) => {
  const hireDate = new Date(rmHireDate);
  const productionDate = new Date(firstProductionDate);

  if (isNaN(hireDate.getTime())) {
    return "Invalid RM Hire Date";
  }

  if (isNaN(productionDate.getTime())) {
    return "Invalid First Production Date";
  }

  if (productionDate < hireDate) {
    return "First Production Date cannot be earlier than RM Hire Date";
  }

  return null; // No error
};